import { render, staticRenderFns } from "./TrCorrelationGraph.vue?vue&type=template&id=3534c2b2&scoped=true"
import script from "./TrCorrelationGraph.vue?vue&type=script&lang=ts"
export * from "./TrCorrelationGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3534c2b2",
  null
  
)

export default component.exports